module.exports = {
  PLX_BEST_PRICE: 'plx-grpa',
  PLX_QUOTE: 'plx-grpb',
  EXCEL_BEST_PRICE: 'excell-grpa',
  EXCEL_QUOTE: 'excell-grpb',
  AMPEL_BEST_PRICE: 'ampel-grpa',
  AMPEL_QUOTE: 'ampel-grpb',
  WHX_BEST_PRICE: 'whx-grpa',
  WHX_QUOTE: 'whx-grpb',
  MAKER_BEST_PRICE: 'panel-share-grpa',
  MAKER_QUOTE: 'panel-share-grpb',
  US_QUOTE_SUFFIX: 'grpa',
  US_BEST_PRICE_SUFFIX: 'grpb',
};
